import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import { useDispatch } from 'react-redux'
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';

export const CSRHeader = () => {
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [userTypeCheck, setUserTypeCheck, userTypeCheckRef] = useStateRef('');
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        setUserTypeCheck(profileDetails.userTypeCheck);
    }, [profileDetails])

    const handleLogOut = (event) => {
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/logout`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    // updating cart count
                    dispatch(updateProfileDetailsAction(true,"logout"))

                    window.location.href = "/"
                }
            })
    };

    return (<>
        <div className="col-12 col-md-7 mb-2 mb-md-0">
            <div className="row csr-padding">
                <dl className="col-10 d-flex">
                    <dt>Logged in as:</dt>
                    <dd>{userTypeCheckRef.current.loggedInAs}
                    </dd>
                </dl>
            </div>
            <div className="row csr-padding">
                <dl className="col-10 d-flex">
                    <dt>Account #:</dt>
                    <dd>
                        {userTypeCheckRef.current.accountNumber}</dd>
                    <dt>Role:</dt>
                    <dd>
                        {userTypeCheckRef.current.role}
                    </dd>
                </dl>
            </div>
        </div>
        <div className="col-12 col-md-5">
            <ul className="list-unstyled d-flex justify-content-center justify-content-md-end mb-0">
                <li><Link to="/csr/csr-search" className="btn btn-primary me-1">Search Users</Link></li>
                <li><Link to="/csr/csr-search" className="btn btn-primary me-1">Search Orders</Link></li>
                <li><a onClick={handleLogOut} className="btn btn-danger">Log Me Out</a></li>
            </ul>
        </div>

    </>)

}